<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <span style="display: inline-block">
    <v-text-field
      v-model="cus_status"
      :background-color="status_color"
      disabled
      dense
      class="mt-2 mb-n5"
      style="width: 130px; border-radius: 3px"
    ></v-text-field>
    <!-- <v-select
      v-model="cus_status"
      :background-color="status_color"
      :items="[
        'รอเสนอราคา',
        'รอวางบิล',
        'รอทำสัญญา',
        'ดำเนินการ',
        'หมดสัญญา',
        'ยกเลิก',
      ]"
      disabled
      dense
      class="mt-2 mb-n5"
      style="width: 130px; border-radius: 3px"
      @change="changeStatus()"
    ></v-select> -->
  </span>
</template>

<script>
export default {
  name: "CustomerStatus",
  props: {
    TableData: Object,
  },
  data: () => ({
    cus_status: "",
    status_color: "#fff",
  }),
  watch: {
    TableData: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        this.cus_status = val.STATUS
        let status = val.STATUS
        this.changeBgColor(status)
      }
    }

  },
  created() {

  },
  methods: {
    changeStatus() {
      let status = this.cus_status
      this.changeBgColor(status)
      this.$token_api
        .post("/update-status-customer", {

          CUSTOMER_ID: this.TableData.NEWCUSTOMER_ID,
          STATUS: this.cus_status
        })
        .then((response) => {
          this.$parent.$parent.$parent.$parent.listOldcustomer()
        })
        .catch((err) => {

        });
    },
    changeBgColor(status) {
      if (status == 'รอเสนอราคา') {
        this.status_color = '#BBDEFB'
      } else if (status == 'รอวางบิล') {
        this.status_color = '#FFF9C4'
      } else if (status == 'รอการชำระเงิน') {
        this.status_color = '#FFF9C4'
      } else if (status == 'รอทำสัญญา') {
        this.status_color = '#FFF9C4'
      } else if (status == 'ดำเนินการ') {
        this.status_color = '#C8E6C9'
      } else if (status == 'หมดสัญญา') {
        this.status_color = '#F48FB1'
      } else if (status == 'ยกเลิก') {
        this.status_color = '#ECEFF1'
      } else {
        this.status_color = '#fff'
      }
    }
  },
};
</script>

